import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Movimentacoes } from '@/pages/movimentacoes';

export const Route = createFileRoute('/a/movimentacoes/')({
    component: Movimentacoes,
    validateSearch: z.object({ tab: z.string().optional() }),
});
